// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","checkboxWrapper":"checkbox_checkboxWrapper__dq7l9"};